export const hotelData = [
    {
        name: 'Sayeman Beach Resort',
        facility1: '2 guests   1 bedrooms   1 beds   1 baths',
        facility2: 'Spa.',
        facility3: 'Semi open & outdoor restaurant.',
        id: 991,
        star: 4.9,
        review: 22,
        price: 43,
        img: 'https://media-cdn.tripadvisor.com/media/photo-w/11/be/3d/98/sea-front-deluxe-supreme.jpg',
        origin: 'coxBazar'
    },
    {
        name: 'Hotel The Cox Today',
        facility1: '4 guests   2 bedrooms   2 beds   2 baths',
        facility2: 'Poolside bar.',
        facility3: 'Car parking.',
        id: 992,
        star: 4.7,
        review: 42,
        price: 66,
        img: 'https://media-cdn.tripadvisor.com/media/photo-w/11/be/3c/7c/hotel-sea-crown.jpg',
        origin: 'coxBazar'
    },
    {
        name: 'Praasad Paradise Hotel & Resort',
        facility1: '6 guests   4 bedrooms   5 beds   3 baths',
        facility2: 'Swimming pool/ Jacuzzi.',
        facility3: 'Public computer.',
        id: 993,
        star: 4.5,
        review: 32,
        price: 89,
        img: 'https://media-cdn.tripadvisor.com/media/photo-w/09/a2/61/3f/photo9jpg.jpg',
        origin: 'coxBazar'
    },
    {
        name: 'Green Leaf Guest House',
        facility1: '10 guests   6 bedrooms   7 beds   4 baths',
        facility2: 'Disable rooms & Interconnecting rooms.',
        facility3: '24 Hour security.',
        id: 994,
        star: 4.8,
        review: 37,
        price: 109,
        img: 'https://media-cdn.tripadvisor.com/media/photo-w/12/d6/64/27/sea-view-juice-bar-and.jpg',
        origin: 'shreemangal'
    },
    {
        name: 'Hotel Skypark',
        facility1: '4 guests   2 bedrooms   2 beds   2 baths',
        facility2: 'Restaurant and Bars',
        facility3: 'Banquet Rooms',
        id: 995,
        star: 4.4,
        review: 32,
        price: 46,
        img: 'https://media-cdn.tripadvisor.com/media/photo-w/11/be/3c/92/hotel-sea-crown.jpg',
        origin: 'shreemangal'
    },
    {
        name: 'Grand Selim Resort',
        facility1: '4 guests   2 bedrooms   2 beds   2 baths',
        facility2: 'Wif Air conditioning Kitchen',
        facility3: 'Cancellation flexibility available',
        id: 996,
        star: 4.8,
        review: 32,
        price: 43,
        img: 'https://media-cdn.tripadvisor.com/media/photo-w/11/be/3c/c5/hotel-sea-crown.jpg',
        origin: 'shreemangal'
    },
    {
        name: 'Divine Centre Ltd, Hotel and Convention Centre',
        facility1: '4 guests   2 bedrooms   2 beds   2 baths',
        facility2: 'Private Beach',
        facility3: 'Cancellation flexibility available',
        id: 997,
        star: 4.3,
        review: 32,
        price: 43,
        img: 'https://media-cdn.tripadvisor.com/media/photo-w/09/a2/61/3c/photo6jpg.jpg',
        origin: 'sundarban'
    },
    {
        name: 'Tiger Garden International Hotel, Khulna Bangladesh',
        facility1: '6 guests   4 bedrooms   5 beds   3 baths',
        facility2: 'Swimming Pool',
        facility3: 'Tennis and Squash',
        id: 998,
        star: 4.5,
        review: 32,
        price: 43,
        img: 'https://media-cdn.tripadvisor.com/media/photo-w/11/be/3c/8b/hotel-sea-crown.jpg',
        origin: 'sundarban'
    },
    {
        name: 'Hotel Royal International',
        facility1: '10 guests   6 bedrooms   7 beds   4 baths',
        facility2: 'Wif Air conditioning Kitchen',
        facility3: 'Live Band',
        id: 999,
        star: 4.2,
        review: 32,
        price: 129,
        img: 'https://media-cdn.tripadvisor.com/media/photo-w/06/05/fc/a2/hotel-sea-crown.jpg',
        origin: 'sundarban'
    }]  